import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const ErrorIcon = ({ fill = 'orange', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 48 48">
            <path
                className={fillStyles}
                d="M24 2C36.1502 2 46 11.8498 46 24C46 36.1502 36.1502 46 24 46C11.8498 46 2 36.1502 2 24C2 11.8497 11.8497 2 24 2ZM24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42C33.941 42 42 33.941 42 24C42 14.0589 33.9411 6 24 6ZM24.0098 30C25.1089 30 26 30.8954 26 32C26 33.1046 25.1089 34 24.0098 34H23.9902C22.8911 34 22 33.1046 22 32C22 30.8954 22.8911 30 23.9902 30H24.0098ZM24 14C25.1046 14 26 14.8954 26 16V24C26 25.1046 25.1046 26 24 26C22.8954 26 22 25.1046 22 24V16C22 14.8954 22.8954 14 24 14Z"
            />
        </svg>
    );
};
